import { useUpdateOptionsMutation } from '@app/store/api/user.api';

/**
 * Saves onboarding tour dismissed state to the backend via /update-options/.
 * Uses the existing updateOptions mutation with FormData.
 *
 * Backend expects merge-semantics: only the provided keys are updated
 * inside user_options or a dedicated onboarding_settings object.
 *
 * For now, uses the existing update-options endpoint with a JSON field.
 * When the backend team adds a dedicated onboarding_settings object,
 * this function can be updated accordingly.
 */
export function useDismissTourMutation() {
  const [updateOptions, meta] = useUpdateOptionsMutation();

  const dismissTour = async (tourId: string) => {
    const formData = new FormData();
    formData.append(`onboarding_${tourId}_dismissed`, 'true');

    try {
      await updateOptions({ body: formData }).unwrap();
    } catch (error) {
      console.error('[Onboarding] Failed to save tour dismissed state:', error);
    }
  };

  return { dismissTour, ...meta };
}
